import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const me = async () => {
    const response = await axios.get(routes.me, AXIOS_DEFAULT_CONFIG);
    return response;
}
export default me;